(function($) {
    'use strict'

    function Gallery(element) {
        this.element = element;

    }


    Gallery.prototype.initLazy = function() {
        var gallery = this;

        new Waypoint({
            element: gallery.element,
            handler: function() {
                if (gallery.wrapperElement == undefined) {
                    gallery.init();
                    //waypoint.destroy();

                    //console.log(this.triggerPoint);
                }
            }
        });
    };

    Gallery.prototype.init = function() {
        var largeGallery = $("<div class='gallery-main' />"),
            thumbGallery = $(this.element),
            galleryWrapper = $('<div class="gallery-wrapper" />');


        $('div.gallery-item', thumbGallery).each(function() {
            var a = $('a', this),
                desc = $('figcaption', this).html(),
                thumb = $(this),
                img = $('img', this),
                //newitem = $('<div />'),
                newimg = $('<img class="full-item owl-lazy owl-height" height="200px" />');



            thumb.data('slideidx', $(this).index());

            thumb.click(function() {
                var idx = $(this).data('slideidx');
                largeGallery.trigger('to.owl.carousel', idx);
                $('div.gallery-item',thumbGallery).removeClass('current');
                $(this).addClass('current')
                return false;
            });


            thumbGallery.addClass('owl-carousel')

            $('div.gallery-item',thumbGallery).first().addClass('current')

            if (thumb.index() == 0) {
                newimg.attr('src', a.attr('href'));
            } else {
                newimg.attr('data-src', a.attr('href'));
            }

            //newitem.append(newimg);
            //
            //if (desc !== undefined) {
            //    newitem.append('<div class="gallery-caption">'+desc+'</div>');
            //}


            largeGallery.append(newimg);
        });

        galleryWrapper.insertBefore(thumbGallery)
            .append(largeGallery)
            .append(thumbGallery);

        $('img',thumbGallery).addClass('lazyload');

        this.wrapperElement = galleryWrapper[0];



        thumbGallery.owlCarousel({
            nav:false,
            dots:false,
            //lazyLoad:true,
            responsiveClass:true,
            responsive:{
                0:{
                    items:3,
                    nav:true
                },
                600:{
                    items:4,
                    nav:false
                },
                1000:{
                    items:6,
                    //nav:true,
                    loop:false
                }
            }
        });


        /**
         * Not really an ideal solution.
         * The first element image isn't loading in time so when the carousel is initialised the
         * first image doesn't have an auto height set. waiting for a while before kicking it off
         * this seems to get around it
         */
        setTimeout(function(){
            $('.gallery-main', this.wrapperElement).owlCarousel({
                autoHeight:true,
                animateOut: 'fadeOut',
                items:1,
                nav:true,
                touchDrag:true,
                mouseDrag:false,
                lazyLoad: true,
            }).addClass('owl-carousel');


            // for whatever reason the first image in the gallery sometimes wasn't being set to opacity 1
            // this is a bit of a hack but it resolves the problem.
            $('.owl-lazy[src]', this.wrapperElement).each(function() {
                $(this).fadeTo( "fast" , 1);
            });

        }, 200);


        //setTimeout(function(){
        //    $('.gallery-main .full-item', this.wrapperElement).each(function() {
        //        lazySizes.loader.unveil($(this)[0]);
        //    });
        //},1000);


        /**
         * This is a hack so that when the browser is resized the height is reset. It looks ugly but
         * the autoheight plugin doesn't seem to do this.
         *
         * @todo find a better way which triggers the resize witout
         */
        $('.gallery-main').on('resized.owl.carousel', function(event){
            var gallery = $(event.target);
            gallery.css('visibility','hidden');
            gallery.trigger('prev.owl.carousel',[0]);
            gallery.trigger('next.owl.carousel',[0]);

            setTimeout(function(){
                gallery.css('visibility','visible');
            },1000);

        });


        /**
         * This loads the next image in the carousel in advance to stop the auto height jumping
         */
        $('.gallery-main').on('loaded.owl.lazy', function(event) {
            var nextpic = new Image();
            var totitem = event.item.count + 2;
            var nextitem = event.item.index + 1;

            if (nextitem <= totitem) {
                var imgsrc = $(event.target).find('.owl-item').eq(nextitem).find('img').data('src');
                nextpic.src = imgsrc;
            }
        });

    };




    window.Gallery = Gallery;
}(jQuery));